<sis-tooltip [tooltipBlockElement]="true" [tooltipText]="explanation">
  <button type="button" class="disabled sis-tooltip-trigger-content" [ngClass]="linkClass" aria-disabled="true" tabindex="0" role="tooltip">
    <ng-content></ng-content>
    <sis-icon *ngIf="isExternal" icon="new-tab"></sis-icon>
  </button>
</sis-tooltip>
